<template>
  <div class="">
    <div class="max-w-screen-xl">
      <div class="grid grid-cols-1 gap-1 mb-9 text-center">
        <h2 class="text-4xl transac-amount text-white-900" style="color: #fff">
          {{ formatPrice(amount) }}
        </h2>
        <h5 class="text-2xl" style="color: #fff">ریال</h5>
      </div>
      <div class="home-bg">
        <div class="grid grid-cols-3 gap-3 mb-5">
          <button class="KeypadButton-s" label="1" @click="append(1)">1</button>
          <button class="KeypadButton-s" @click="append('2')">2</button>
          <button class="KeypadButton-s" @click="append('3')">3</button>
          <button class="KeypadButton-s" @click="append('4')">4</button>
          <button class="KeypadButton-s" @click="append('5')">5</button>
          <button class="KeypadButton-s" @click="append('6')">6</button>
          <button class="KeypadButton-s" @click="append('7')">7</button>
          <button class="KeypadButton-s" @click="append('8')">8</button>
          <button class="KeypadButton-s" @click="append('9')">9</button>
          <KeypadButtonBell />
          <button class="KeypadButton-s" @click="append('0')">0</button>
          <KeypadButtonBackspace @click="remove" />
        </div>
        <div>
          <!-- <KeypadButton label="دریافت" /> -->
          <!-- <KeypadButton label="پرداخت" @click="transaction" /> -->
          <div class="key-btn">
            <img
              src="@/assets/img/pay.svg"
              class="pay-btn"
              @click="transaction"
            />
            <img src="@/assets/img/receive.svg" class="send-btn" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import KeypadButton from "@/components/KeypadButton.vue";
import KeypadButtonBell from "@/components/KeypadButtonBell.vue";
import KeypadButtonBackspace from "@/components/KeypadButtonBackspace.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "Home",
  components: {
    // KeypadButton,
    KeypadButtonBell,
    KeypadButtonBackspace,
  },
  setup() {
    const router = useRouter();
    let amount = ref("0");

    function append(label) {
      if (amount.value === "0") {
        amount.value = label;
        formatPrice(amount);
      } else {
        amount.value += label;
        formatPrice(amount);
      }
    }

    function remove() {
      if (amount.value.length > 1) {
        amount.value = amount.value.substring(0, amount.value.length - 1);
      } else {
        amount.value = "0";
      }
    }

    function formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toLocaleString("fa-IR").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function transaction() {
      router.push({ name: "Destination", params: { amount: amount.value } });
    }

    return {
      amount,
      append,
      remove,
      transaction,
      formatPrice,
    };
  },
};
</script>
<style scoped>
.text-indigo-600 {
  color: black;
  font: 15px vazir;
}
.pay-btn {
  width: 112px;
  background-color: #ddd;
  padding: 26px;
  border-radius: 0px 50px 50px 0;
  margin-left: 8px;
  height: 70px;
}
.send-btn {
  width: 112px;
  background-color: #ddd;
  padding: 26px;
  border-radius: 50px 0px 0px 50px;
  height: 70px;
}
.key-btn {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
}
</style>
